import React, { useState, useRef } from 'react';
import {
  Grid,
  FormControl,
  Select,
  MenuItem,
  TextField,
  Button,
  Paper,
  Typography,
  Alert,
  Box,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Card,
  CardContent,
  CardHeader
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Visibility, Save as SaveIcon, Clear as ClearIcon, Send as SendIcon, Assignment as AssignmentIcon, Create as SignatureIcon } from '@mui/icons-material';
import TextareaAutosize from '@mui/base/TextareaAutosize';
import { EnviarCorreopdf, TareasProveedor, ingresoPDFWorkmanagerFlujo, TareasProveedorObseracion, ingresoDOCXWorkmanagerFlujo } from '../FunctionLogin'
import { generatePDF } from '../FuncionPDF'
import SignatureCanvas from "react-signature-canvas";
import swal from 'sweetalert';
import PDFPreviewDialog from './PDFPreviewDialog';

// --- Styled Components (Premium Glassmorphism) ---

// Generador de UUID alternativo si crypto.randomUUID no está disponible
function generateUUID() {
  if (window.crypto && window.crypto.randomUUID) {
    return window.crypto.randomUUID();
  }
  // fallback simple
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

const GlassContainer = styled(Paper)(({ theme }) => ({
  backgroundColor: 'rgba(255, 255, 255, 0.95)',
  backdropFilter: 'blur(20px)',
  borderRadius: '24px',
  boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
  padding: theme.spacing(4),
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
  maxWidth: '1200px',
  marginLeft: 'auto',
  marginRight: 'auto',
  border: '1px solid rgba(255, 255, 255, 0.18)',
}));

const StyledCard = styled(Card)(({ theme }) => ({
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
  borderRadius: '16px',
  boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
  marginBottom: theme.spacing(4),
  border: '1px solid rgba(0,0,0,0.05)'
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  color: '#34495e',
  marginBottom: theme.spacing(2),
  textTransform: 'uppercase',
  letterSpacing: '1px',
  fontSize: '1.2rem',
  borderBottom: '2px solid #3f51b5',
  display: 'inline-block',
  paddingBottom: '4px'
}));

const StyledTableCellHead = styled(TableCell)(({ theme }) => ({
  backgroundColor: '#f8f9fa',
  color: '#2d3436',
  fontWeight: 700,
  borderBottom: '2px solid #e9ecef',
  textTransform: 'uppercase',
  fontSize: '0.85rem',
}));

const StyledTableCellBody = styled(TableCell)(({ theme }) => ({
  fontSize: '0.9rem',
  borderBottom: '1px solid #f1f3f5',
}));

const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: '50px',
  padding: '12px 28px',
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '1px',
  fontSize: '1.1rem',
  boxShadow: '0 4px 14px 0 rgba(33,150,243,0.10)',
  transition: 'all 0.25s cubic-bezier(.4,2,.6,1)',
  background: 'linear-gradient(90deg, #1976d2 0%, #64b5f6 100%)',
  color: '#fff',
  '&:hover': {
    transform: 'scale(1.04) translateY(-2px)',
    boxShadow: '0 8px 24px 0 rgba(33,150,243,0.18)',
    background: 'linear-gradient(90deg, #1565c0 0%, #90caf9 100%)',
  },
  '&:active': {
    background: 'linear-gradient(90deg, #1976d2 0%, #64b5f6 100%)',
  },
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    borderRadius: '12px',
    transition: 'all 0.3s cubic-bezier(.4,2,.6,1)',
    '& fieldset': {
      borderColor: 'rgba(0, 0, 0, 0.1)',
    },
    '&:hover fieldset': {
      borderColor: theme.palette.primary.main,
      boxShadow: '0 0 0 2px #90caf9',
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.primary.main,
      borderWidth: '2px',
      boxShadow: '0 4px 20px rgba(33,150,243,0.08)',
    },
    '&.Mui-focused': {
      backgroundColor: '#fff',
    }
  },
  '& .MuiInputLabel-root': {
    color: '#546e7a',
    fontWeight: 500,
  },
  '& .Mui-error .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.error.main,
  },
}));

export default function EvaluationVisita() {
  const optionsContacto = [
    'VENTAS',
    'CALIDAD',
    'COMERCIO INTERNACIONAL',
    "OTRO"
  ];

  const sigPad = useRef({});
  const sigPad2 = useRef({});




  const [loading, setLoading] = useState(false);
  const [firmaFile, setFirmaFile] = useState(null); // Puede ser base64 o URL
  const [firmaFile2, setFirmaFile2] = useState(null);
  const [firmaFile2Loading, setFirmaFile2Loading] = useState(false);
  const [firmaFile2Error, setFirmaFile2Error] = useState(null);
  const [firmaFileLoading, setFirmaFileLoading] = useState(false);
  const [firmaFileError, setFirmaFileError] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [pdfBase64, setPdfBase64] = useState('');
  const [showPdfPreview, setShowPdfPreview] = useState(false);
  const [rows, setRows] = useState([{
    contacto: 'VENTAS',
    nombre: '',
    telefono: '',
    email: '',
  },
  {
    contacto: 'CALIDAD',
    nombre: '',
    telefono: '',
    email: '',
  },
  {
    contacto: 'COMERCIO INTERNACIONAL',
    nombre: '',
    telefono: '',
    email: '',
  }
    ,
  {
    contacto: 'OTRO',
    nombre: '',
    telefono: '',
    email: '',
  }]);





  const handleRowChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  const options = [
    'SERVICIOS DE TRANSPORTE NACIONAL',
    'SERVICIOS INFORMÁTICOS',
    'SERVICIOS MECANIZADOS O METALMECÁNICOS',
    'SERVICIOS DE AGENCIA DE ADUANAS',
    'SERVICIOS DE TRANSPORTE INTERNACIONAL',
    'SERVICIOS DE PAQUETEO',
    'SERVICIOS DE INGENIERÍA',
    'SERVICIOS LEGALES',
    'SERVICIOS CONTABLES E IMPUESTOS',
    'SERVICIOS LOGÍSTICOS',
    'SUMINISTROS MATERIAS PRIMAS',
    'SUMINISTROS MATERIAL DE EMPAQUE',
    'SUMINISTROS REPUESTOS',
    'SUMINISTROS MAQUINARIA Y EQUIPOS PARA LA VENTA',
    'SUMINISTROS DE CONSUMIBLES Y ACCESORIOS PARA LA VENTA',
    'ALMACENAMIENTO',
    "ENSAYOS DE LABORATORIO",
    "SELLOS DE SEGURIDAD"
  ];


  const [fechaDiligenciamiento, setFechaDiligenciamiento] = useState('');

  const [responsableVisita, setResponsableVisita] = useState('');
  const [responsableRecibir, setResponsableRecibir] = useState('');

  const [pais, setPais] = useState(localStorage.Pais);
  const [razonSocial, setRazonSocial] = useState(localStorage.Tproveedor);
  const [email, setEmail] = useState();
  const [direccion, setDireccion] = useState(localStorage.Direcc);
  const [vinculosCiTalsa, setVinculosCiTalsa] = useState('');
  const [ciudad, setCiudad] = useState(localStorage.Ciudad);
  const [telefono, setTelefono] = useState(localStorage.Telefono);
  const [promedio, setPromedio] = useState('');
  const [opcionSeleccionada, setOpcionSeleccionada] = useState('');
  const [opcionSeleccionadaContacto, setOpcionSeleccionadaContacto] = useState('');

  const handleFechaDiligenciamientoChange = (event) => {
    setFechaDiligenciamiento(event.target.value);
  };

  const handlePaisChange = (event) => {
    setPais(event.target.value);
  };

  const handleRazonSocialChange = (event) => {
    setRazonSocial(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleDireccionChange = (event) => {
    setDireccion(event.target.value);
  };

  const handleVinculosCiTalsaChange = (event) => {
    setVinculosCiTalsa(event.target.value);
  };

  const handleCiudadChange = (event) => {
    setCiudad(event.target.value);
  };
  const handleTelefonoChangeChange = (event) => {
    setTelefono(event.target.value);
  };
  const handlePromedioChangeChange = (event) => {
    setPromedio(event.target.value);
  };

  const handleOpcionSeleccionadaContactoChange = (event) => {
    setOpcionSeleccionadaContacto(event.target.value);
  };
  const handleOpcionSeleccionadaChange = (event) => {
    setOpcionSeleccionada(event.target.value);
  };


  const handleResponsableVisitaChangeChange = (event) => {
    setResponsableVisita(event.target.value);
  };
  const handleResponsableRecibirChangeChange = (event) => {
    setResponsableRecibir(event.target.value);
  };



  const [comments, setComments] = useState(Array(60).fill(''));
  const [observacion, setObservacion] = useState(Array(60).fill(''));
  const [fecha, setFecha] = useState(Array(60).fill(''));



  const [observacionTotal, setObservacionTotal] = useState('');


  const evaluationData = [
    {
      category: 'A. INSTALACIONES FISICAS',
      questions: [
        {
          question: '1. ¿La compañía cuenta con una infraestructura adecuada y segura para llevar a cabo su actividad económica? (verifique las instalaciones físicas)',
          index: 0,
        },
        {
          question: '2. ¿Las áreas de manejo, almacenamiento, cargue y descargue de mercancías se encuentran debidamente delimitadas y se controla el acceso al personal autorizado?',
          index: 1,
        },
        {
          question: '3. ¿La compañía dispone de una central de monitoreo tanto dentro como fuera de las instalaciones para garantizar la seguridad del producto o servicio suministrado?',
          index: 2,
        },
        {
          question: '4. ¿La compañía cuenta con un sistema de vigilancia y seguridad implementado?',
          index: 3,
        },
        {
          question: '5. ¿Las bodegas de la compañía cuentan con cerramientos seguros para proteger la mercancía?',
          index: 4,
        },
        {
          question: '6. ¿La compañía tiene personal de vigilancia en las instalaciones?',
          index: 5,
        },
        {
          question: '7. ¿La compañía cuenta con controles de acceso a sus instalaciones (personas, vehículos)?',
          index: 6,
        },
        {
          question: '8. ¿Existen procedimientos para limpieza, orden y desinfección de áreas?',
          index: 7,
        },
        {
          question: '9. ¿Se cuenta con un programa de mantenimiento locativo?',
          index: 8,
        },
        {
          question: '10. ¿Existe un programa de control de plagas?',
          index: 9,
        },
      ],
    },
    {
      category: 'B. ASOCIADO DE NEGOCIO: PROVEEDORES',
      questions: [
        {
          question: '1. ¿La compañía tiene procesos escritos para la evaluación y selección de asociados de negocio? En caso afirmativo, por favor relacione el código del procedimiento respectivo.',
          index: 10,
        },
        {
          question: '2. ¿Se evidencia control y gestión del abastecimiento y capacidades para cumplir con los requisitos de los pedidos?',
          index: 11,
        },
        {
          question: '3. ¿Cuenta la compañía con un plan de contingencia y/o continuidad de negocio?',
          index: 12,
        },
        {
          question: '4. ¿Cuenta con un sistema de registro, análisis y atención de quejas y reclamos de los asociados de negocio?',
          index: 13,
        },
        {
          question: '5. ¿La compañía cuenta con pólizas de seguro todo riesgo para las mercancías transportadas y almacenadas que sean propiedad de TALSA?',
          index: 14,
        },
        {
          question: '6. ¿Cuenta con herramientas que permitan gestionar la trazabilidad y seguimiento de la entrega de los pedidos en tiempo real?',
          index: 15,
        },
        {
          question: '7. ¿Cuándo subcontrata alguno de sus procesos críticos relacionados con la cadena de suministros, realiza estudios de seguridad a estos asociados del negocio?',
          index: 16,
        },
        {
          question: '8. ¿El personal que maneja nuestras cargas es personal directo?',
          index: 17,
        },
      ],
    },
    {
      category: 'C. GESTIÓN DE COMPRAS',
      questions: [
        {
          question: '1. ¿Tiene establecidos controles en la recepción de sus materiales y/o servicios?',
          index: 18,
        },
        {
          question: '2. ¿Cuenta con planes de inspección, control, pruebas de conformidad y/o disposición para sus materiales y/o servicios? ',
          index: 19,
        },
        {
          question: '3. ¿Identifica adecuadamente los materiales comprados, aceptados, rechazados y en proceso de ser inspeccionados?',
          index: 20,
        },
        {
          question: '4. ¿Cuenta con un sistema de selección y evaluación de asociados de negocio que garantice la seguridad de su cadena de suministro?',
          index: 21,
        },
        {
          question: '5. ¿Tiene definidas disposiciones para el adecuado almacenamiento de sus materias primas, teniendo en cuenta las medidas de seguridad de la mercancía? (Ejemplo: contaminación, hurto, entre otras)',
          index: 22,
        },
        {
          question: '6. ¿Tiene implementadas medidas de seguridad orientadas a mitigar riesgos en la cadena de suministro (nacional o internacional)?',
          index: 24,
        },
        {
          question: '7. ¿Cuenta con procedimientos documentados para garantizar la integridad y seguridad de la carga en los procesos de manejo, almacenamiento y transporte?',
          index: 25,
        },
        {
          question: '8. ¿Tiene procedimientos documentados para garantizar que la información de despacho o recepción de carga sea veraz y esté protegida contra cambios, pérdidas o introducción de datos erróneos?',
          index: 26,
        },
      ],
    },
    {
      category: 'D. CONTROL DE LA PRODUCCIÓN, SEGURIDAD DEL PERSONAL Y PRESTACIÓN DEL SERVICIO',
      questions: [
        {
          question: '1. ¿Controla y documenta los parámetros de calidad del proceso durante la producción y/o prestación del servicio?',
          index: 27,
        },
        {
          question: '2. ¿Realiza pruebas de conformidad a los productos terminados y/o a la calidad del servicio según corresponda?',
          index: 28,
        },
        {
          question: '3. ¿Identifica adecuadamente el producto terminado aprobado, rechazado y en proceso de ser inspeccionado? Para el caso de servicios, ¿identifica antes, durante y posterior a la prestación del mismo que cumplan los estándares de calidad declarados en sus procedimientos?',
          index: 29,
        },
        {
          question: '4. ¿Cuenta con disposiciones para el manejo de su producto terminado no conforme? En el caso de servicios, ¿dispone de mecanismos para la gestión y mejora continua de los servicios que no se ejecuten según lo acordado?',
          index: 30,
        },
        {
          question: '5. ¿Cuenta con un programa de mantenimiento preventivo y realiza mantenimiento correctivo a la maquinaria o equipos utilizados en la producción o prestación de servicios que brinda a TALSA? Por favor, proporcionar registros que confirmen su cumplimiento.',
          index: 31,
        },
        {
          question: '6. ¿Tiene implementado un programa de calibración, revisión y mantenimiento de los equipos de medición asociados a la calidad de los productos o servicios que comercializa?',
          index: 32,
        },
        {
          question: '7. ¿Dispone de fichas técnicas y hojas de seguridad de los productos que comercializa, o protocolos de nivel de servicio para cada uno de los servicios que suministra a TALSA?',
          index: 33,
        },
        {
          question: '8. ¿Se tienen procedimientos para la selección del personal a vincular en la compañía, que incluyan medidas de seguridad?',
          index: 34,
        },
      ],
    },
    {
      category: 'E. GESTIÓN AMBIENTAL',
      questions: [
        {
          question: '1. ¿Tiene establecida una política de gestión ambiental y sostenibilidad?',
          index: 35,
        },
        {
          question: '2. ¿Su compañía cuenta con certificados, reconocimientos o convenios de gestión ambiental? En caso afirmativo, ¿cuáles?',
          index: 36,
        },
        {
          question: '3. ¿Cuenta con una matriz de impactos ambientales dentro de su organización? ¿Cuáles son los impactos más significativos?',
          index: 37,
        },
        {
          question: '4. ¿Cuenta con planes de acción para mitigar los impactos ambientales, objetivos y metas?',
          index: 38,
        },
        {
          question: '5. ¿Ha establecido procedimientos para atender posibles emergencias ambientales relacionadas con su actividad?',
          index: 39,
        },
      ],
    },
    {
      category: 'F. BENEFICIO E INTERÉS COLECTIVO',
      questions: [
        {
          question: '1. ¿Se tienen relaciones comerciales con empresas de origen local o que pertenezcan a mujeres y minorías?',
          index: 50,
        },
        {
          question: '2. ¿Se cuenta con un manual para los colaboradores de la compañía donde se apoye la inclusión de personas con distintas culturas, minorías étnicas, creencias religiosas diversas, con distintas orientaciones sexuales, capacidades físicas heterogéneas y diversidad de género?',
          index: 51,
        },
        {
          question: '3. ¿Qué beneficios se otorgan a los colaboradores? (Salarios justos, incentivos educativos, economicos, sociales, entre otros)',
          index: 52,
        },
        {
          question: '4. ¿Se realizan controles periodicos sobre la eficiencia de uso de energía, agua y desechos?',
          index: 53,
        },
        {
          question: '5. ¿Se incentivan las actividades de voluntariado, obras sociales y apoyo a fundaciones?',
          index: 54,
        }
      ]
    },
    {
      category: 'F. GESTIÓN DE SEGURIDAD',
      questions: [
        {
          question: '1. ¿Tiene implementado un sistema de gestión de la seguridad industrial y la seguridad y salud en el trabajo en toda su cadena de suministros y comercio exterior?',
          index: 40,
        },
        {
          question: '2. ¿Controla el embalaje de sus productos?',
          index: 41,
        },
        {
          question: '3. ¿La empresa controla y registra los medios de distribución (transporte) de sus productos?',
          index: 42,
        },
        {
          question: '4. ¿Identifica adecuadamente los productos según su peligrosidad?',
          index: 43,
        },
        {
          question: '5. ¿La compañía cuenta con código de conducta para asociados de negocio o que incluya este grupo de interés a través del cual se transmitan los valores y principios de la empresa?',
          index: 44,
        },
        {
          question: '6. ¿Cuenta con un sistema de autocontrol para la gestión, prevención y control de los riesgos asociados al lavado de activos, financiación del terrorismo (LA/FT) y otros riesgos en su cadena de suministros?',
          index: 45,
        },
        {
          question: '7. ¿La empresa cuenta con registros de los resultados de la identificación de peligros y la evaluación y valoración de riesgos, incluyendo actividades rutinarias y no rutinarias (IPVR)?',
          index: 46,
        },
        {
          question: '8. ¿Cuenta con el respectivo permiso o autorización de la entidad reglamentaria correspondiente para su funcionamiento (si aplica) ?',
          index: 47,
        },
        {
          question: '9. ¿Cuenta con uno o varios sistemas de gestión? En caso afirmativo, indique cuáles son.',
          index: 48,
        },
        {
          question: '10. ¿Cuenta con ceriticaciones de sistemas de gestion u otro reconocimiento relacionado?',
          index: 49,
        }
      ],
    },
  ];


  const asociados = [
    { tipo: 'FAVORABLE', puntaje: '> 80', accion: 'Enfatizar los puntos fuertes para que sostenga la posición y los no tan fuertes para que los mejore.', control: 'No requiere verificación' },
    { tipo: 'FAVORABLE CONDICIONAL', puntaje: '> 60 y <= 80', accion: 'Presentar los puntos débiles para que implemente acciones.', control: 'Verificación eventual a los tres meses' },
    { tipo: 'NO FAVORABLE', puntaje: '> 0 y <= 60', accion: 'Se le informa al asociado que no ha cumplido con los parámetros esperados para continuar contando con sus servicios NO FAVORABLE.', control: 'Estudiar los planes de acción enviados por el proveedor' },
  ];


  const [evaluations, setEvaluations] = useState(Array(54).fill(0));

  const handleEvaluationChange = (index, value) => {
    setEvaluations((prevEvaluations) => {
      const newEvaluations = [...prevEvaluations];
      newEvaluations[index] = value;
      // Visibility logic is now handled in Render based on this state
      return newEvaluations;
    });
  };

  const [totalPoints, setTotalPoints] = useState(0);

  const sumPoints = () => {
    const sum = evaluations.reduce((total, evaluation) => total + evaluation, 0);
    setTotalPoints(sum);
  };


  const handleCommentChange = (index, value) => {
    setComments((prevComments) => {
      const newComments = [...prevComments];
      newComments[index] = value;
      return newComments;
    });
  };
  const handleObservacionChange = (index, value) => {
    setObservacion((prevComments) => {
      const newComments = [...prevComments];
      newComments[index] = value;
      return newComments;
    });
  };
  const handleFechaChange = (index, value) => {
    setFecha((prevComments) => {
      const newComments = [...prevComments];
      newComments[index] = value;
      return newComments;
    });
  };








  const evaluationRef = useRef(null);




  return (
    <GlassContainer ref={evaluationRef} elevation={3}>
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 800, color: '#1a237e' }}>
          VISITA ASOCIADOS DE NEGOCIO
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
          Gestión de Proveedores
        </Typography>
      </Box>

      {/* Module 1: General Information */}
      <StyledCard elevation={0}>
        <CardHeader
          title={<SectionTitle>Información General</SectionTitle>}
          avatar={<AssignmentIcon color="primary" />}
          sx={{ pb: 0 }}
        />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <StyledTextField
                label="Fecha de Diligenciamiento"
                type="date"
                fullWidth
                value={fechaDiligenciamiento}
                onChange={handleFechaDiligenciamientoChange}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <StyledTextField
                label="País"
                fullWidth
                value={pais}
                onChange={handlePaisChange}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <StyledTextField
                label="Razón Social"
                fullWidth
                value={razonSocial}
                onChange={handleRazonSocialChange}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <StyledTextField
                label="Email"
                fullWidth
                value={email}
                onChange={handleEmailChange}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <StyledTextField
                label="Dirección"
                fullWidth
                value={direccion}
                onChange={handleDireccionChange}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <StyledTextField
                label="Años Vinculado con Talsa"
                fullWidth
                value={vinculosCiTalsa}
                onChange={handleVinculosCiTalsaChange}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <StyledTextField
                label="Ciudad"
                fullWidth
                value={ciudad}
                onChange={handleCiudadChange}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <StyledTextField
                label="Teléfono"
                fullWidth
                value={telefono}
                onChange={handleTelefonoChangeChange}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <StyledTextField
                label="¿A cuánto ascienden las compras en promedio del último año?"
                fullWidth
                value={promedio}
                onChange={handlePromedioChangeChange}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth sx={{ mb: 4 }}>
                <StyledTextField
                  select
                  label="Producto o Servicios que Suministra"
                  value={opcionSeleccionada}
                  onChange={handleOpcionSeleccionadaChange}
                  variant="outlined"
                >
                  {options.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </StyledTextField>
              </FormControl>
            </Grid>
          </Grid>
        </CardContent>
      </StyledCard>

      <TableContainer component={Paper} elevation={0} sx={{ mb: 4, borderRadius: 2, border: '1px solid #e0e0e0' }}>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCellHead>CONTACTO</StyledTableCellHead>
              <StyledTableCellHead>NOMBRE</StyledTableCellHead>
              <StyledTableCellHead>TELÉFONO</StyledTableCellHead>
              <StyledTableCellHead>EMAIL</StyledTableCellHead>

            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={index} hover>
                <StyledTableCellBody>
                  <Select
                    value={row.contacto}
                    fullWidth
                    variant="standard"
                    disableUnderline
                    onChange={(e) => handleRowChange(index, 'contacto', e.target.value)}
                  >
                    {optionsContacto.map((option) => (
                      <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                  </Select>
                </StyledTableCellBody>
                <StyledTableCellBody>
                  <StyledTextField
                    fullWidth
                    variant="standard"
                    value={row.nombre}
                    onChange={(e) => handleRowChange(index, 'nombre', e.target.value)}
                    InputProps={{ disableUnderline: true }}
                  />
                </StyledTableCellBody>
                <StyledTableCellBody>
                  <StyledTextField
                    fullWidth
                    variant="standard"
                    value={row.telefono}
                    onChange={(e) => handleRowChange(index, 'telefono', e.target.value)}
                    InputProps={{ disableUnderline: true }}
                  />
                </StyledTableCellBody>
                <StyledTableCellBody>
                  <StyledTextField
                    fullWidth
                    variant="standard"
                    value={row.email}
                    onChange={(e) => handleRowChange(index, 'email', e.target.value)}
                    InputProps={{ disableUnderline: true }}
                  />
                </StyledTableCellBody>

              </TableRow>
            ))}
          </TableBody>
        </Table>

      </TableContainer>

      <TableContainer component={Paper} style={{ width: "100%", border: "1px solid", margin: "auto", padding: "0px" }}>
        <Table >
          <TableHead>
            <TableRow>
              <TableCell>
                <h4>SISTEMA DE PUNTUACIÓN</h4>
              </TableCell>
              <TableCell>
                <h4>Categoría</h4>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                1
              </TableCell>
              <TableCell>
                No cumple
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                2
              </TableCell>
              <TableCell>
                Cumple parcialmente
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                3
              </TableCell>
              <TableCell>
                Cumple
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>




      <TableContainer component={Paper} elevation={0} sx={{ maxHeight: "600px", maxWidth: "100%", overflowY: "auto", border: '1px solid #e0e0e0', borderRadius: 2 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <StyledTableCellHead>Categoría</StyledTableCellHead>
              <StyledTableCellHead>Preguntas</StyledTableCellHead>
              <StyledTableCellHead align="center">Evaluación</StyledTableCellHead>
              <StyledTableCellHead>Comentarios / Observaciones</StyledTableCellHead>
            </TableRow>
          </TableHead>
          <TableBody>
            {evaluationData.map((category, categoryIndex) => (
              <React.Fragment key={categoryIndex}>
                {category.questions.map((question, questionIndex) => (
                  <TableRow key={`${categoryIndex}-${questionIndex}`}>
                    {questionIndex === 0 && (
                      <StyledTableCellBody
                        sx={{ fontWeight: 'bold', backgroundColor: '#fafafa', borderRight: '1px solid #eee' }}
                        rowSpan={category.questions.length}
                      >
                        {category.category}
                      </StyledTableCellBody>
                    )}

                    <StyledTableCellBody sx={{ width: '40%' }}>
                      {question.question}
                    </StyledTableCellBody>

                    <StyledTableCellBody align="center">
                      <Select
                        value={evaluations[question.index] || ''}
                        onChange={(event) => handleEvaluationChange(question.index, event.target.value)}
                        sx={{ minWidth: 80, height: 40 }}
                      >
                        <MenuItem value={1}>1 (No)</MenuItem>
                        <MenuItem value={2}>2 (Parcial)</MenuItem>
                        <MenuItem value={3}>3 (Si)</MenuItem>
                      </Select>
                    </StyledTableCellBody>

                    <StyledTableCellBody sx={{ width: '30%' }}>
                      <StyledTextField
                        fullWidth
                        size="small"
                        placeholder="Comentario general"
                        value={comments[question.index] || ''}
                        onChange={(event) => handleCommentChange(question.index, event.target.value)}
                        sx={{ mb: 1 }}
                      />

                      {/* Conditional Fields based on Evaluation */}
                      {evaluations[question.index] == 1 && (
                        <Box sx={{ mt: 1, p: 1, bgcolor: '#fff3e0', borderRadius: 1 }}>
                          <Typography variant="caption" color="warning.main" fontWeight="bold">
                            Observación Requerida:
                          </Typography>
                          <StyledTextField
                            fullWidth
                            multiline
                            rows={2}
                            size="small"
                            placeholder="Describa la no conformidad"
                            value={observacion[question.index] || ''}
                            onChange={(event) => handleObservacionChange(question.index, event.target.value)}
                            sx={{ mt: 0.5, mb: 1 }}
                          />
                          <StyledTextField
                            type="date"
                            fullWidth
                            size="small"
                            label="Fecha Compromiso"
                            InputLabelProps={{ shrink: true }}
                            value={fecha[question.index] || ''}
                            onChange={(event) => handleFechaChange(question.index, event.target.value)}
                          />
                        </Box>
                      )}
                    </StyledTableCellBody>
                  </TableRow>
                ))}
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom color="textSecondary">Observaciones Generales</Typography>
        <StyledTextField
          fullWidth
          multiline
          rows={4}
          value={observacionTotal}
          onChange={(e) => setObservacionTotal(e.target.value)}
          variant="outlined"
          placeholder="Ingrese observaciones generales sobre la evaluación total..."
        />
      </Box>
      <StyledCard elevation={0}>
        <CardHeader
          title={<SectionTitle>Resultados de Evaluación</SectionTitle>}
          sx={{ pb: 0 }}
        />
        <CardContent>
          <Typography style={{ fontWeight: "bold", color: "red", marginBottom: '16px' }}>
            Nota: Todos los númerales que contengan observaciones deberán contar con un plan de acción, el cual debe de ser documentado en los próximos tres(3) meses
          </Typography>
          <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #e0e0e0', borderRadius: 2 }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <StyledTableCellHead>Calificación</StyledTableCellHead>
                  <StyledTableCellHead>Puntaje</StyledTableCellHead>
                  <StyledTableCellHead>Acción a seguir</StyledTableCellHead>
                  <StyledTableCellHead>Control</StyledTableCellHead>
                </TableRow>
              </TableHead>
              <TableBody>
                {asociados.map((asociado, index) => (
                  <TableRow key={index} hover>
                    <StyledTableCellBody sx={{ fontWeight: 'bold' }}>{asociado.tipo}</StyledTableCellBody>
                    <StyledTableCellBody>{asociado.puntaje}</StyledTableCellBody>
                    <StyledTableCellBody>{asociado.accion}</StyledTableCellBody>
                    <StyledTableCellBody>{asociado.control}</StyledTableCellBody>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Box sx={{ mt: 3, p: 2, bgcolor: '#e8f5e9', borderRadius: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Typography variant="h6" color="success.dark" gutterBottom>
              CALIFICACIÓN FINAL: <strong>{((totalPoints / ((evaluations.length) * 3)) * 100).toFixed(2)} %</strong>
            </Typography>
            <Chip
              label={
                (((totalPoints / ((evaluations.length) * 3)) * 100).toFixed(2) > 80 ? "FAVORABLE" : ((totalPoints / ((evaluations.length) * 3)) * 100).toFixed(2) > 60
                  && ((totalPoints / ((evaluations.length) * 3)) * 100).toFixed(2) <= 80 ? "FAVORABLE CONDICIONAL" : "NO FAVORABLE")
              }
              color={
                (((totalPoints / ((evaluations.length) * 3)) * 100).toFixed(2) > 80 ? "success" : ((totalPoints / ((evaluations.length) * 3)) * 100).toFixed(2) > 60
                  && ((totalPoints / ((evaluations.length) * 3)) * 100).toFixed(2) <= 80 ? "warning" : "error")
              }
              sx={{ fontWeight: 'bold', fontSize: '1rem', px: 2 }}
            />
          </Box>
        </CardContent>
      </StyledCard>


      <StyledCard elevation={0} sx={{ border: '1px solid #bbdefb' }}>
        <CardHeader
          title={<SectionTitle>Firmas y Aprobación</SectionTitle>}
          avatar={<SignatureIcon color="primary" />}
        />
        <CardContent>
          <Grid container spacing={4} justifyContent="center" alignItems="stretch">
            {/* Signature 1 */}
            <Grid item xs={12} md={6}>
              <Paper elevation={0} sx={{ p: 3, border: '1px solid #e0e0e0', borderRadius: 2, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#fafafa' }}>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom color="primary">
                  RESPONSABLE EJECUTAR VISITA
                </Typography>
                <StyledTextField
                  label="Nombre Completo"
                  fullWidth
                  variant="standard"
                  sx={{ mb: 3 }}
                  value={responsableVisita}
                  onChange={(e) => setResponsableVisita(e.target.value)}
                />
                <Box sx={{ border: '2px solid #bdbdbd', borderRadius: 1, overflow: 'hidden', bgcolor: '#fff' }}>
                  <SignatureCanvas
                    canvasProps={{
                      width: 400,
                      height: 180,
                      className: 'sigCanvas',
                    }}
                    ref={sigPad}
                  />
                </Box>
                <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
                  <Button variant="outlined" startIcon={<ClearIcon />} color="error" size="small" onClick={() => { sigPad.current.clear(); setFirmaFile(null); setFirmaFileError(null); }}>
                    Limpiar
                  </Button>
                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    color="primary"
                    size="small"
                    disabled={firmaFileLoading}
                    onClick={async () => {
                      sumPoints();
                      setFirmaFileLoading(true);
                      setFirmaFileError(null);
                      try {
                        const canvas = sigPad.current.getCanvas();
                        const dataUrl = canvas.toDataURL("image/png");
                        const base64 = dataUrl.split(",")[1];
                        const nombreArchivo = `firma_${generateUUID()}.png`;
                        const body = {
                          base64: `data:image/png;base64,${base64}`,
                          nombreArchivo,
                          tipoArchivo: "image/png"
                        };
                        const response = await fetch("https://consumos.talsa.com.co/api/talsa/proveedores/img-proveedor", {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json"
                          },
                          body: JSON.stringify(body)
                        });
                        let result = null;
                        try {
                          result = await response.json();
                        } catch (jsonErr) {
                          setFirmaFileError("Respuesta inválida del servidor. ¿CORS o error de red?");
                          console.error("Respuesta no JSON:", jsonErr, response);
                          return;
                        }
                        console.log("Respuesta firma:", result);
                        if (result && result.success && result.url) {
                          setFirmaFile(result.url);
                          swal("Guardado", "Firma guardada", "success");
                        } else {
                          setFirmaFileError("No se pudo guardar la firma. " + (result && result.message ? result.message : "Intente de nuevo."));
                          console.error("Error en respuesta firma:", result);
                        }
                      } catch (err) {
                        setFirmaFileError("Error al subir la firma: " + (err && err.message ? err.message : err));
                        console.error("Error de red al subir firma:", err);
                      } finally {
                        setFirmaFileLoading(false);
                      }
                    }}
                  >
                    {firmaFileLoading ? "Guardando..." : "Guardar"}
                  </Button>
                  {firmaFileError && (
                    <Alert severity="error" sx={{ mt: 1 }}>{firmaFileError}</Alert>
                  )}
                </Box>
              </Paper>
            </Grid>

            {/* Signature 2 */}
            <Grid item xs={12} md={6}>
              <Paper elevation={0} sx={{ p: 3, border: '1px solid #e0e0e0', borderRadius: 2, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#fafafa' }}>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom color="primary">
                  RESPONSABLE RECIBIR VISITA
                </Typography>
                <StyledTextField
                  label="Nombre Completo"
                  fullWidth
                  variant="standard"
                  sx={{ mb: 3 }}
                  value={responsableRecibir}
                  onChange={(e) => setResponsableRecibir(e.target.value)}
                />
                <Box sx={{ border: '2px solid #bdbdbd', borderRadius: 1, overflow: 'hidden', bgcolor: '#fff', mb: 1 }}>
                  {firmaFile2 && firmaFile2.startsWith("http") ? (
                    <img src={firmaFile2} alt="Firma guardada" style={{ width: 400, height: 180, objectFit: 'contain', background: '#fff' }} />
                  ) : (
                    <SignatureCanvas
                      canvasProps={{
                        width: 400,
                        height: 180,
                        className: 'sigCanvas',
                      }}
                      ref={sigPad2}
                    />
                  )}
                </Box>
                <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
                  <Button variant="outlined" startIcon={<ClearIcon />} color="error" size="small" onClick={() => { sigPad2.current.clear(); setFirmaFile2(null); setFirmaFile2Error(null); }}>
                    Limpiar
                  </Button>
                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    color="primary"
                    size="small"
                    disabled={firmaFile2Loading}
                    onClick={async () => {
                      sumPoints();
                      setFirmaFile2Loading(true);
                      setFirmaFile2Error(null);
                      try {
                        const canvas = sigPad2.current.getCanvas();
                        const dataUrl = canvas.toDataURL("image/png");
                        const base64 = dataUrl.split(",")[1];
                        const nombreArchivo = `firma_${generateUUID()}.png`;
                        const body = {
                          base64: `data:image/png;base64,${base64}`,
                          nombreArchivo,
                          tipoArchivo: "image/png"
                        };
                        const response = await fetch("https://consumos.talsa.com.co/api/talsa/proveedores/img-proveedor", {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json"
                          },
                          body: JSON.stringify(body)
                        });
                        let result = null;
                        try {
                          result = await response.json();
                        } catch (jsonErr) {
                          setFirmaFile2Error("Respuesta inválida del servidor. ¿CORS o error de red?");
                          console.error("Respuesta no JSON:", jsonErr, response);
                          return;
                        }
                        console.log("Respuesta firma2:", result);
                        if (result && result.success && result.url) {
                          setFirmaFile2(result.url);
                          swal("Guardado", "Firma guardada", "success");
                        } else {
                          setFirmaFile2Error("No se pudo guardar la firma. " + (result && result.message ? result.message : "Intente de nuevo."));
                          console.error("Error en respuesta firma2:", result);
                        }
                      } catch (err) {
                        setFirmaFile2Error("Error al subir la firma: " + (err && err.message ? err.message : err));
                        console.error("Error de red al subir firma2:", err);
                      } finally {
                        setFirmaFile2Loading(false);
                      }
                    }}
                  >
                    {firmaFile2Loading ? "Guardando..." : "Guardar"}
                  </Button>
                  {firmaFile2Error && (
                    <Alert severity="error" sx={{ mt: 1 }}>{firmaFile2Error}</Alert>
                  )}
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </CardContent>
      </StyledCard>

      <Alert severity="warning" sx={{ mb: 3 }}>
        Recuerde guardar el documento y las firmas antes de enviar.
      </Alert>

      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <StyledButton
          variant="contained"
          color="primary"
          disabled={loading}
          onClick={() => {
            setLoading(true);
            const tableData = [];
            evaluationData.forEach((category) => {
              const categoryData = {
                category: category.category,
                questions: [],
              };
              category.questions.forEach((question) => {
                const questionData = {
                  question: question.question,
                  evaluation: evaluations[question.index] || "",
                  comment: comments[question.index] || "",
                  observation: observacion[question.index] || "",
                  fecha: fecha[question.index] || "",
                };
                categoryData.questions.push(questionData);
              });
              tableData.push(categoryData);
            });

            const camposRequeridos = [
              { campo: 'fechaDiligenciamiento', valor: fechaDiligenciamiento, mensaje: 'Fecha de diligenciamiento' },
              { campo: 'pais', valor: pais, mensaje: 'País' },
              { campo: 'razonSocial', valor: razonSocial, mensaje: 'Razón social' },
              { campo: 'telefono', valor: telefono, mensaje: 'Teléfono' },
              { campo: 'direccion', valor: direccion, mensaje: 'Dirección' },
              { campo: 'vinculosCiTalsa', valor: vinculosCiTalsa, mensaje: 'Tiempo de vinculación con Talsa' },
              { campo: 'ciudad', valor: ciudad, mensaje: 'Ciudad' },
              { campo: 'promedio', valor: promedio, mensaje: 'Compras en el último año' },
              { campo: 'opcionSeleccionada', valor: opcionSeleccionada, mensaje: 'Suministros' },
            ];

            for (let campo of camposRequeridos) {
              if (!campo.valor || campo.valor.trim() === '') {
                swal({
                  title: 'Campos Vacíos',
                  text: `Campo faltante: ${campo.mensaje}`,
                  icon: 'warning',
                });
                setLoading(false);
                return false;
              }
            }

            if (!firmaFile || !firmaFile2) {
              swal("Atención", "Se requieren ambas firmas (Guarde cada firma antes de enviar)", "warning");
              return;
            }

            setLoading(true);

            // Google Apps Script Integration
            const appScriptData = {
              "fechadilencia": fechaDiligenciamiento,
              "pais": pais,
              "razonsocial": razonSocial,
              "telefono": telefono,
              "direccion": direccion,
              "tiempotalsa": vinculosCiTalsa,
              "ciudad": ciudad,
              "comprasultimosano": promedio,
              "servicioquesuministra": opcionSeleccionada,
              "observacionestotal": observacionTotal,
              "puntosobtenidos": totalPoints.toString(),
              "puntosposibles": (evaluations.length * 3).toString(),
              "preguntasaplicables": evaluations.length.toString(),
              "calificacion": `${((totalPoints / (evaluations.length * 3)) * 100).toFixed(2)}%`,
              "responsable1": responsableVisita,
              "responsable2": responsableRecibir,
              "firma1": firmaFile,
              "firma2": firmaFile2
            };

            // Add contacts (max 4 as per requested JSON)
            rows.forEach((row, i) => {
              if (i < 4) {
                appScriptData[`nombre${i + 1}`] = row.nombre || "";
                appScriptData[`telefono${i + 1}`] = row.telefono || "";
                appScriptData[`email${i + 1}`] = row.email || "";
              }
            });

            // Map all 54 questions
            let qNum = 1;
            evaluationData.forEach(category => {
              category.questions.forEach(question => {
                const idx = question.index;
                appScriptData[`evaluacion${qNum}`] = evaluations[idx] ? evaluations[idx].toString() : "";
                appScriptData[`comentario${qNum}`] = comments[idx] || "";
                appScriptData[`observaciones${qNum}`] = observacion[idx] || "";
                appScriptData[`fecha${qNum}`] = fecha[idx] || "";
                qNum++;
              });
            });

            const appScriptUrl = "https://script.google.com/macros/s/AKfycbxe4uFpcH_zviP1vhOAmgSEB58qy_BPO7VykzTzu9DjIYj-mQE4NrWpWc0D8FtuRaxZ3g/exec";

            fetch(appScriptUrl, {
              method: 'POST',
              headers: {
                "Content-Type": "text/plain;charset=utf-8"
              },
              body: JSON.stringify(appScriptData)
            })
              .then(response => response.json())
              .then(result => {
                setLoading(false);
                console.log("Respuesta del servidor:", result);

                swal("Exitoso", "Evaluación enviada correctamente", "success");

                // Extraer la URL del PDF de la respuesta
                if (result && result.pdf && result.pdf.url) {
                  console.log("📄 URL del PDF recibida:", result.pdf.url);
                  setPdfUrl(result.pdf.url);

                  // Generar base64 localmente para el envío por correo sin fallos de CORS
                  const calificacionFinal = ((totalPoints / (evaluations.length * 3)) * 100).toFixed(2);
                  generatePDF(fechaDiligenciamiento, rows, tableData, calificacionFinal, firmaFile, firmaFile2, pais, razonSocial, telefono, direccion, vinculosCiTalsa, ciudad, promedio, opcionSeleccionada, responsableVisita, responsableRecibir).then(base64 => {
                    setPdfBase64(base64);
                    setShowPdfPreview(true);
                  }).catch(err => {
                    console.error("Error al generar PDF local:", err);
                    setShowPdfPreview(true); // Mostrar de todos modos aunque falle la generación local
                  });
                } else {
                  console.warn("⚠️ No se recibió URL del PDF en la respuesta");
                }
              })
              .catch(e => {
                console.error("Error App Script:", e);
                setLoading(false);
                swal("Error", "No se pudo enviar la evaluación", "error");
              });
          }}
          startIcon={loading ? null : <SendIcon />}
          size="large"
        >
          {loading ? "Enviando..." : "Enviar Información"}
        </StyledButton>
      </Box>

      {/* PDF Preview Dialog */}
      <PDFPreviewDialog
        open={showPdfPreview}
        pdfUrl={pdfUrl}
        onClose={() => setShowPdfPreview(false)}
        title="Vista Previa - Evaluación de Visita"
        supplierName={razonSocial}
        evaluationType="Evaluación de Visita"
        pdfBase64={pdfBase64}
      />

    </GlassContainer>
  );
}
